import { BillingCycle } from "../components/showPurchaseOrder/GeneratePO"
import { PaymentTerm, SubmissionType, TaxTerm } from "./ConsultantMast"
import { POStatus } from "./PurchaseOrder"

export const JobType = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Onsite" },
    { id: 2, name: "Hybrid" },
    { id: 3, name: "Remote" },
]
export const Term = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Contract" },
    { id: 2, name: "Contract-to-Hire" },
    { id: 3, name: "Permanent" },
]
export const Priority = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Low" },
    { id: 2, name: "High" },
    { id: 3, name: "Very High" },
]
export const InterviewProcess = [
    { id: 0, name: "-- SELECT --" },
    { id: 1, name: "Telephonic" },
    { id: 2, name: "F2F" },
    { id: 3, name: "Skype" },
    { id: 4, name: "Tele + F2F" },
    { id: 5, name: "Skype + F2F" },
    { id: 6, name: "Tel/Skype + F2F" },
    { id: 7, name: "Telephonic / F2F" },
    { id: 8, name: "Tel/Webex" },
    { id: 9, name: "Tel/Zoom" },
    { id: 10, name: "Tel/Spark Hire" },
]
export const client_Type = [
    { id: 1, clientTypeName: 'Direct Client' },
    { id: 2, clientTypeName: 'Implementing Partner' }
]
export const special_Constraints = [
    { name: 'PV W2' },
    { name: 'OUR W2' },
    { name: 'Active Security Clearance' },
    { name: 'No Constraints' },
    { name: 'In Person' },
    { name: 'Local' },
    { name: 'Genuine Visa' },
]
export const EClient_Communication = [
    { name: "-- SELECT --" },
    { name: "Phone" },
    { name: "Email" },
    { name: "Chat" },
]

export const PODocType = [
    { name: "Consultant" },
    { name: "Vendor" },
    { name: "Client" },
]
export const ECIType = [
    { name: "Telephonic", id: 1 },
    { name: "In Person", id: 2, },
    { name: "Skype", id: 3 },
    { name: "Tele + F2F", id: 9 },
    { name: "Skype + F2F", id: 4 },
    { name: "Tel/Skype + F2F", id: 5 },
    { name: "Telephonic / F2F", id: 11 },
]
export const Positions = [
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" },
    { id: 8, name: "8" },
    { id: 9, name: "9" },
    { id: 10, name: "10" },
    { id: 11, name: "11" },
    { id: 12, name: "12" },
    { id: 13, name: "13" },
    { id: 14, name: "14" },
    { id: 15, name: "15" },
    { id: 16, name: "16" },
    { id: 17, name: "17" },
    { id: 18, name: "18" },
    { id: 19, name: "19" },
    { id: 20, name: "20" }
]
export const ResumesPerPositions = [
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" },
    { id: 8, name: "8" },
    { id: 9, name: "9" },
    { id: 10, name: "10" },
    { id: 11, name: "11" },
    { id: 12, name: "12" },
    { id: 13, name: "13" },
    { id: 14, name: "14" },
    { id: 15, name: "15" },
    { id: 16, name: "16" },
    { id: 17, name: "17" },
    { id: 18, name: "18" },
    { id: 19, name: "19" },
    { id: 20, name: "20" }
]
export const Experience = [
    { name: 1 },
    { name: 2 },
    { name: 3 },
    { name: 4 },
    { name: 5 },
    { name: 6 },
    { name: 7 },
    { name: 8 },
    { name: 9 },
    { name: 10 },
    { name: 11 },
    { name: 12 },
    { name: 13 },
    { name: 14 },
    { name: 15 },
    { name: 16 },
    { name: 17 },
    { name: 18 },
    { name: 19 },
    { name: 20 }
]
export const NoticePeriod = [
    { value: "0", name: "Immediate" },
    { value: "7", name: "One Week" },
    { value: "15", name: "Two Week" },
    { value: "30", name: "One Month" },
    { value: "60", name: "Two Month" },
    { value: "90", name: "Three Month" }
]
export const Tax_Term = [
    { id: TaxTerm.C2C_With_Benefits, name: "C2C with Benefits" },
    { id: TaxTerm.C2C_All_Inclusive, name: "C2C All Inclusive" },
    { id: TaxTerm.Tax_1099_All_Inclusive, name: "1099 All Inclusive" },
    { id: TaxTerm.Tax_1099_With_Benefits, name: "1099 with Benefits" },
    { id: TaxTerm.W2_All_Inclusive, name: "W2 All Inclusive" },
    { id: TaxTerm.W2_With_Benefits, name: "W2 with Benefits" },
    { id: TaxTerm.Permanent, name: "Permanent" }
]

export const Payment_Term = [
    { name: "-- SELECT --", id: null },
    { name: "Net 30", id: PaymentTerm.Net_Thirty },
    { name: "Net 45", id: PaymentTerm.Net_Forty_Five },
    { name: "Pay on Pay", id: PaymentTerm.Pay_On_Pay },
    { name: "Net 15", id: PaymentTerm.Net_Fifteen },
    { name: "Net 60", id: PaymentTerm.Net_Sixty },
    { name: "Net 7", id: PaymentTerm.Net_Seven }
];
export const PaymentTermMap = Object.fromEntries(
    Payment_Term.map(x => [x.id, x.name])
);
export const Billing_Cycle = [
    { name: "-- SELECT --", id: null },
    { name: "Weekly", id: BillingCycle.Weekly },
    { name: "Bi-Weekly", id: BillingCycle.BiWeekly },
    { name: "4-Weekly", id: BillingCycle.FourWeekly },
    { name: "Semi-Monthly", id: BillingCycle.SemiMonthly },
    { name: "Monthly", id: BillingCycle.Monthly },
    { name: "Custom", id: BillingCycle.Custom }
];
export const BillingCycleMap = Object.fromEntries(
    Billing_Cycle.map(x => [x.id, x.name])
);
export const PO_Status = [
    { name: "-- SELECT --", id: null },
    { name: "To Join", id: POStatus.To_Join },
    { name: "Fizzled", id: POStatus.Fizzled },
    { name: "Joined", id: POStatus.Joined },
    { name: "Ended", id: POStatus.Ended },
];
export const POStatusMap = Object.fromEntries(
    PO_Status.map(x => [x.id, x.name])
);

export const MatchingPer = [
    { name: 50 },
    { name: 60 },
    { name: 70 },
    { name: 80 },
    { name: 90 },
    { name: 100 }
]
export const Submission_Type = [
    { id: SubmissionType.Contract, name: "Contract" },
    { id: SubmissionType.Permanent, name: "Permanent" },
    { id: SubmissionType.C2C, name: "C2C" }
]
export const ServedStatus = [
    { name: "-- SELECT --" },
    { name: "Served" },
    { name: "Unserved" },
    { name: "UnAllocated" },
    { name: "Rejected" }
]
export const Status = [
    { name: "-- SELECT --", value: null },
    { name: "Hold", value: true },
    { name: "Unhold", value: false }
]
export const TicketStatus = [
    { name: "Open" },
    { name: "InProgress" },
    { name: "Hold" },
    { name: "Answered" },
    { name: "Closed" }
]
